export const ONBOARDING_TOURS_SOURCE_KEY = 'ONBOARDING_TOURS_SOURCE_KEY';
export const ONBOARDING_TOURS_GUIDE = 'ONBOARDING_TOURS_GUIDE';
export const ONBOARDING_TOURS_GROUP_KEY = 'ONBOARDING_TOURS_GROUP_KEY';